const modules = import.meta.glob('./language/**/*.js')
const messages = {}

for (const path in modules) {
  // const name = path.split('/')[2]
  // console.log(modules[path].default)
  // messages[name] = modules[path].default
  modules[path]().then(mod => {
    const paths = path.split(/\/|\./g)
    const name1 = paths[3]
    const name2 = paths[4]
    if (!messages[name1]) {
      messages[name1] = {}
    }
    messages[name1][name2] = mod.default
  })
}
export default messages
